<app-header [progress]="3" [title]="locale.currentTranslation.tripInformationHeader" data-testid="fault-allocation-header"></app-header>
<div class="base-content-container" data-testid="fault-allocation-container">
  <div class="headline3" data-testid="fault-allocation-title">{{ locale.currentTranslation.faultAllocation1 }}
  </div>
  <div style="display: flex; flex-direction: column; gap: 24px;" data-testid="radio-options">
    @for (option of options; track option) {
      <div class="radio-button-base" [attr.data-testid]="'radio-option-' + option.value">
        <div>
          <input type="radio"
                 [value]="option.value"
                 [formControl]="radioControl"
                 [attr.data-testid]="'radio-input-' + option.value"
                 [attr.aria-labelledby]="'radio-label-' + option.value">
        </div>
        <div (click)="setOption(option.value)" (keydown.enter)="setOption(option.value)" role="button" tabindex="0" [attr.data-testid]="'radio-label-container-' + option.value">
          <div class="label1" [attr.id]="'radio-label-' + option.value" [attr.data-testid]="'radio-headline-' + option.value">{{ option.headline }}</div>
          <div class="caption1" [attr.data-testid]="'radio-caption-' + option.value">{{ option.caption }}</div>
        </div>
      </div>
    }
  </div>
  @if (showError) {
    <div class="caption1 error-text" data-testid="validation-error" role="alert">
      {{ locale.currentTranslation.errorMessageUserInputNotChosen }}
    </div>
  }
  <div class="divider"></div>
  <button (click)="triggerHint()"
        class="button-as-div"
        type="button"
        data-testid="hint-toggle">
    <img height="20" ngSrc="assets/img/info-icon.svg" width="20">
    <div class="label2">
      {{ locale.currentTranslation.additionInformation }}
    </div>
    <img [ngSrc]="showAdditionalInformation() ? 'assets/img/up-carret.svg' : 'assets/img/down-carret.svg'" height="20"
         width="20">
  </button>
  @if (showAdditionalInformation()) {
    <div data-testid="additional-info-content">
      <div class="text-body1">
        <span>{{ locale.currentTranslation.faultAllocationHint }}</span>
      </div>
    </div>
  }
</div>
<div class="main-button-spacing">
  <button (click)="nextClicked()" class="main-button" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="fault-allocation-footer"></app-footer>
